export default {
    cellars:[],
    cellar:{relaciones:{productos:{}}},
}
